// base
import BaseTable from "./components/base/BaseTable";
import BaseTable1 from "./components/base/BaseTable1";

import Blank from "./components/base/Blank";
import Button from "./components/base/Button";
import Card from "./components/base/Card";
import Checkbox from "./components/base/Checkbox";
import Collapse from "./components/base/Collapse";
import ColorPicker from "./components/base/ColorPicker";
import Dialog from "./components/base/Dialog";
import Dropdown from "./components/base/Dropdown";
import DatePicker from "./components/base/DatePicker";
import Icon from "./components/base/Icon";
import Image from "./components/base/Image";
import Input from "./components/base/Input";
import Label from "./components/base/Label";
import Loading from "./components/base/Loading";
import MessageBox from "./components/base/MessageBox";
import Notify from "./components/base/Notify";
import Pagination from "./components/base/Pagination";
import Radio from "./components/base/Radio";
import Range from "./components/base/Range";
import Select from "./components/base/Select";
import Slider from "./components/base/Slider";
import Switch from "./components/base/Switch";
import Tab from "./components/base/Tab";
import Tag from "./components/base/Tag";
import Tooltip from "./components/base/Tooltip";
import Upload from "./components/base/Upload";
import Download from "./components/base/Download";
import Drawer from "./components/base/Drawer";
import Menu from "./components/base/Menu";
import DropdownMenu from "./components/base/DropdownMenu";
import AutoComplete from "./components/base/AutoComplete";
import ContextMenu from "./components/base/ContextMenu";
import ProcedureProgress from "./components/base/ProcedureProgress";
import NumberInput from "./components/base/NumberInput";
// advance;
import InputField from "./components/advance/InputField";
import LinkMenu from "./components/advance/LinkMenu";
import PaginationTable from "./components/advance/PaginationTable";
import SearchInput from "./components/advance/SearchInput";
import ScrollPageButtons from "./components/advance/ScrollPageButtons";

const componentsTree = {
  base: {
    BaseTable,
    BaseTable1,
    Blank,
    Button,
    Card,
    Checkbox,
    Collapse,
    ColorPicker,
    Drawer,
    Dialog,
    Dropdown,
    DatePicker,
    Icon,
    Image,
    Input,
    Label,
    Loading,
    MessageBox,
    Notify,
    Pagination,
    Radio,
    Range,
    Select,
    Slider,
    Tab,
    Tag,
    Tooltip,
    Switch,
    Upload,
    Download,
    Menu,
    DropdownMenu,
    AutoComplete,
    ContextMenu,
    ProcedureProgress,
    NumberInput
  },
  advance: {
    InputField,
    LinkMenu,
    PaginationTable,
    SearchInput,
    ScrollPageButtons
  }
};

const components = {};

Object.values(componentsTree).forEach(cmptGroup => {
  Object.values(cmptGroup).forEach(cmptGroupValue => {
    Object.assign(components, cmptGroupValue);
  });
});

const Components = {
  install(Vue, opt = {}) {
    Vue.prototype.$SJ_COMPONENTS_CONFIG = opt;

    Object.values(components).forEach(cmpt => {
      cmpt.install(Vue);
    });
  }
};

console.log(components);

export { components };

export default Components;
